import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from "../../login/services/auth.service";
import { AssessmentService } from "../../shared/services/assessment.service";
import { AssessmentGraderService } from "../../shared/services/assessment-grader.service";
import { ReportService } from 'app/reports/services/report.service';
import { ClientService } from 'app/shared/services/client.service';
import { AlertService } from 'app/shared/services/alert.service';
var TakeAssessmentComponent = /** @class */ (function () {
    function TakeAssessmentComponent(AssessmentService, router, authService, route, assessmentGrader, clientService, reportService, alertService) {
        this.AssessmentService = AssessmentService;
        this.router = router;
        this.authService = authService;
        this.route = route;
        this.assessmentGrader = assessmentGrader;
        this.clientService = clientService;
        this.reportService = reportService;
        this.alertService = alertService;
        this._currentIndex = 0;
        this._maxQuestionSetsIndex = 0;
    }
    TakeAssessmentComponent.prototype.ngOnInit = function () {
        // this.loading = true;
        var _this = this;
        this.authService.getCurrentClient().then(function (client) {
            _this._client = client;
            // not sure I like this nested, but it does handle duplicate requests for the uid.
            _this.route.params.subscribe(function (params) {
                var uid = params['uid'];
                _this.AssessmentService.uid = uid;
                _this.AssessmentService.clientId = client.id;
                // TODO: stephen this is a dangerous assumption but we can use it for now
                // we need to restructure things to use the assignment, not the test uid, as a user 
                // could have more than one test assigned... although this is unlikely
                _this.setupAssignment(client, uid);
                if (_this.hasAssignment()) {
                    _this.navigateToAssignmentResultForClient(client, uid, _this._assignment.ResultId, _this._assignment);
                }
                else {
                    _this.loadAssessment(uid);
                }
            });
        });
    };
    TakeAssessmentComponent.prototype.setupAssignment = function (client, uid) {
        this._assignment = client.findAssignmentItemForAssessmentUid(uid);
    };
    TakeAssessmentComponent.prototype.hasAssignment = function () {
        return this._assignment && this._assignment.ResultId;
    };
    TakeAssessmentComponent.prototype.navigateToAssignmentResultForClient = function (client, uid, resultId, assignmentItem) {
        var _this = this;
        var assignment = this._client.findAssignmentForAssignmentItem(assignmentItem);
        this.reportService.getReportsForAssignment(assignment)
            .then(function (reports) {
            if (reports && reports.length) {
                var singleReport = reports[0];
                _this.router.navigate(['assessments', client.id, 'reports', singleReport.id, assignment.Id]);
            }
            else {
                // we go to the default location if there is no reports.
                _this.router.navigate(["assessments", client.id, "result", resultId]);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    TakeAssessmentComponent.prototype.loadAssessment = function (uid) {
        var _this = this;
        this.AssessmentService.getAssessment(uid).then(function (assessment) {
            _this.loading = false;
            _this._assessment = assessment;
        })
            .catch(function (response) {
            _this.loading = false;
            console.error(response);
        });
    };
    Object.defineProperty(TakeAssessmentComponent.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssessmentComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (v) {
            this._loading = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssessmentComponent.prototype, "saving", {
        get: function () {
            return this._saving;
        },
        set: function (v) {
            this._saving = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssessmentComponent.prototype, "saveError", {
        get: function () {
            return this._saveError;
        },
        set: function (v) {
            this._saveError = v;
        },
        enumerable: true,
        configurable: true
    });
    TakeAssessmentComponent.prototype.shouldRedirect = function () {
        return this.redirectUrl != null;
    };
    TakeAssessmentComponent.prototype.redirectToNewUrl = function () {
        // TODO: make this the hydrated url
        window.location.href = this.redirectUrl;
    };
    TakeAssessmentComponent.prototype.submit = function (assessment) {
        var _this = this;
        this.saveError = false;
        this.saving = false;
        var result = this.assessmentGrader.grade(assessment);
        result.assignmentItemId = (this._assignment ? this._assignment.Id : null);
        this.saving = true;
        var savingMsg = this.alertService.info("Computing your test results and saving your scores....", 600000);
        this.AssessmentService.saveAssessmentResult(result)
            .then(function (result) {
            _this.alertService.success("Saved results for " + assessment.name);
            _this.alertService.clearAlert(savingMsg);
            // reload the client, grab the assignment and let's continue
            // TODO: stephen I don't like this... we need to return the assignment but we don't have it on the server...
            // how can we move forward with this?
            return _this.clientService.getClient(_this._client.id)
                .then(function (client) {
                _this.setupAssignment(client, assessment.uid);
                _this.navigateToAssignmentResultForClient(_this._client, _this.assessment.uid, result.id, _this._assignment);
            });
        }, function () {
            console.error("Failed to save json result");
            this.saving = false;
            this.saveError = true;
        });
    };
    return TakeAssessmentComponent;
}());
export { TakeAssessmentComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/take-assessment/take-assessment.component.ts.pre-build-optimizer.js